import { ACP } from '../constants.mjs';
import { setAgentAccess } from './setAgentAccess.mjs';

//
/**
 * Set access for the public.
 *
 * @param resourceWithAcr URL of the Resource you want to read the access for.
 * @param access Access Modes you want to set for the agent.
 * @since 1.16.0
 */
async function setPublicAccess(resourceWithAcr, access) {
    return setAgentAccess(resourceWithAcr, ACP.PublicAgent, access);
}

export { setPublicAccess };
